import React, { useEffect, useState } from 'react'
import jsPDF from 'jspdf'
import xlsx from 'xlsx'
import { applyPlugin } from 'jspdf-autotable'
import 'primereact/resources/primereact.min.css'
import 'primereact/components/datatable/DataTable.css'
import 'primeicons/primeicons.css'
import 'primereact/resources/primereact.css'
import './prime.css'
import { DataTable as PRDatatable, DataTableProps } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { InputText } from 'primereact/inputtext'
import { Button } from 'primereact/button'
import excelIcon from '../assets/images/excel.png'
import PdfIcon from '../assets/images/pdf.png'
import Storage from 'util/store/Storage'
import { esDominioFuelly, esNumero, snakeCaseToSeparatedUppercase, snakeCaseToSeparatedUppercase2 } from 'util/utils'
applyPlugin(jsPDF)

export interface ColumnsDatatable {
    field: string
    header: string
    number?: boolean | number
    frozen?: boolean
    style?: React.CSSProperties
}
export interface ColumnsPDF {
    header: string
    dataKey: string
}
export interface PropsDatatable extends DataTableProps {
    data: any[]
    columns: ColumnsDatatable[]
    columnsPDF?: ColumnsDatatable[]
    noExport?: boolean
    fontSize?: number
    nombreExcel?: string
    valueSearch?: string
    paperSheetSizePdf?: string | number[]
    headerRigth?: boolean
    nombrePDf?: string
    noRefresh?: boolean
    select?: any
    haveFormat?: any[]
    noPuntos?: boolean
    noPdf?: boolean
    hasTag?: boolean
    styledColumns?: { [key: string]: React.CSSProperties }
    noExcel?: boolean
    extra?: React.ReactNode
    extra2?: React.ReactNode
    style?: React.CSSProperties
    worksheetName?: string
    idCy?: string
    onRefresh?: any
    ignoreFormat?: string[]
    currencyColumns?: string[]
    /** Paginación servidor: total de registros */
    totalRecords?: number
    /** Paginación servidor: índice del primer registro (first = page * rows) */
    first?: number
    /** Paginación servidor: callback al cambiar página (event: { first, rows }) */
    onPage?: (event: { first: number; rows: number }) => void

    /**callback para obtener todos los datos al exportar (cuando usas paginación servidor) */
    fetchAllForExport?: () => Promise<any[]>
    /**callback para obtener todos los datos con forma de tabla (con acciones); si no se pasa, se usa fetchAllForExport para el buscador en todas las páginas */
    fetchAllForFilter?: () => Promise<any[]>
    /** Callback opcional para notificar cambios en el texto del buscador (por ejemplo, para filtrar en el backend). */
    onFilterChange?: (value: string) => void
    /** Si se pasa, la lupa/Enter envían el texto al backend y se desactiva el filtro local / fetchAllForFilter. */
    onSearch?: (value: string) => void
    /** Texto opcional junto al ícono de exportar (por ejemplo "Descargar en Excel"). Sin él solo se muestra el ícono. */
    etiquetaExcel?: string
    etiquetaPdf?: string
}
// @ts-ignore
const DataTableFilterDemo: React.FC<PropsDatatable> = props => {
    const {
        valueSearch = '',
        data,
        columns,
        styledColumns = {},
        extra,
        extra2,
        hasTag = false,
        headerRigth = false,
        columnsPDF = columns,
        noExport = false,
        rows = 10,
        fontSize = 9,
        nombreExcel = 'Excel',
        nombrePDf = 'PDF',
        className,
        noRefresh = false,
        haveFormat = [],
        noPuntos = false,
        noPdf = false,
        noExcel = false,
        worksheetName = 'data',
        idCy = 'demo',
        ignoreFormat = [],
        paperSheetSizePdf = 'legal'
    } = props
    const [globalFilter, setGlobalFilter] = useState('')
    const useLazyPagination = props.totalRecords != null && typeof props.onPage === 'function'
    const [allDataCache, setAllDataCache] = useState<any[] | null>(null)
    const [loadingAllForFilter, setLoadingAllForFilter] = useState(false)
    const [filterFirst, setFilterFirst] = useState(0)
    const [filterRows, setFilterRows] = useState(rows)
    const [sortField, setSortField] = useState<string | null>(null)
    const [sortOrder, setSortOrder] = useState<number>(1)
    const [multiSortMeta, setMultiSortMeta] = useState<Array<{ field: string; order: number }> | null>(null)
    const { actualizarvista } = Storage.getState()
    const [exporting, setExporting] = useState(false)

    // funcion para catualizar la vista donde se envuentra el componente
    const actualizar = async () => {
        // Validar si viene la prop onRefresh, si no entonces poner por defecto actualizarvista
        if (props.onRefresh) {
            await props.onRefresh()
        } else {
            Storage.dispatch({
                type: 'ACTUALIZACION_DATOS',
                actualizarvista: !actualizarvista
            })
        }
    }

    const textoCentrado = (doc: any, text: string, alto: number): any => {
        const textWidth = (doc.getStringUnitWidth(text) * doc.internal.getFontSize()) / doc.internal.scaleFactor
        const textOffset = (doc.internal.pageSize.width - textWidth) / 2
        return doc.text(textOffset, alto, text)
    }

    useEffect(() => {
        setGlobalFilter(valueSearch)
    }, [valueSearch])

    // funcion para exportar pdf
    const exportPdf = (dataToExport: any[]): void => {
        const headersNoPrint = ['ACCIONES', 'ACCION', 'VER', 'DETALLES', 'DETALLE', 'OPCIONES', 'OPCION', 'BORRAR']
        const doc: any = new jsPDF('l', 'pt', paperSheetSizePdf)
        const data2 = hasTag
            ? dataToExport.map(key => (key.estado.props.children ? { ...key, estado: key.estado.props.children } : key))
            : dataToExport
        doc.setFontSize(14)
        textoCentrado(doc, nombrePDf, 20)
        doc.setFont('helvetica', 'italic')
        doc.setFontSize(10)
        doc.autoTable({
            startY: 50,
            body: data2,
            columns: columnsPDF.map(
                columna =>
                    !headersNoPrint.includes(columna.header.toUpperCase()) && {
                        header: columna.header,
                        dataKey: columna.field
                    }
            ),
            styles: { fontSize: fontSize },
            headStyles: { fillColor: [186, 0, 0] },
            columnStyles: styledColumns
        })
        doc.save(nombrePDf + '.pdf')
    }

    const formatearValue = (value: any, key: string) => {
        if (ignoreFormat.includes(key)) return value + ''
        if (typeof value === 'string') {
            value = value
                .replace(/\$/g, '')
                .replace(/\./g, noPuntos ? '.' : '') //agregue esa validacion para que no elimine las comas en los lugares que asi lo requieren
                .replace(/,/g, noPuntos ? ',' : '.')
            if (!esNumero(value.trim())) return value
            if (value.includes('/') || value.includes(':')) return value
            return parseFloat(value)
        }
        return value
    }

    const reemplazarComasYdolar = (value: any) => {
        value = value
            .replace(/\$/g, '')
            .replace(/\./g, noPuntos ? '.' : '') //agregue esa validacion para que no elimine las comas en los lugares que asi lo requieren
            .replace(/,/g, noPuntos ? ',' : '.')
        if (!esNumero(value.trim())) return value
        if (value.includes('/') || value.includes(':')) return value
        return parseFloat(value)
    }

    const formatearPrecios = (value: any) => {
        if (typeof value === 'string') {
            if (noPuntos && value.includes('$')) {
                value = Number(
                    value
                        .trim()
                        .replace(/\$/g, '')
                        .replace(/,/g, '')
                )
            } else {
                value = reemplazarComasYdolar(value)
            }
        }
        if (value == false) return ''
        return value
    }

    const formatearExcel = (datos: any) => {
        if (datos) {
            return datos.map((data: any) => {
                return Object.entries(data).reduce((obj: any, [key, value]) => {
                    obj[key] =
                        noPuntos && !ignoreFormat.includes(key) ? formatearPrecios(value) : formatearValue(value, key)
                    return obj
                }, {})
            })
        } else {
            return []
        }
    }

    const deleteColumns = ['acciones', 'ventas']
    const exportExcel = (dataToExport: any[]) => {
        const currencyColumns = props.currencyColumns || []
        const excelColumns = props.columnsPDF ? props.columnsPDF : props.columns
        //Filtro de acciones para que al exportar el documento tenga en cuenta no exportar tambien la columna y no se rompa la web
        const dataColumns = excelColumns.map(col => col.field).filter(x => !deleteColumns.includes(x))
        const dataColumnsObj = Object.fromEntries(excelColumns.map(col => [col.field, 0]))
        // para mi dentro de 1 mes esto es para obtener solo las columnas que se ven en la vista
        const objData = dataToExport.map(dat =>
            Object.fromEntries(
                Object.entries(Object.assign(dataColumnsObj, dat)).filter(entrie => dataColumns.includes(entrie[0]))
            )
        )
        const { usuario } = Storage.getState()
        const worksheet = xlsx.utils.json_to_sheet(
            !esDominioFuelly(usuario.dominio)
                ? formatearExcel(
                    hasTag ? snakeCaseToSeparatedUppercase(objData) : snakeCaseToSeparatedUppercase2(objData)
                )
                : objData
        )

        // Este verifica segun los parametros que reciba las filas que tengan codigo de barras y les hace un formato para que no se muestre la notación cientifica.
        if (haveFormat.length > 0) {
            for (let s in worksheet) {
                for (const key in haveFormat) {
                    if (s.toString()[0] === haveFormat[key] && worksheet[s].t === 'n') {
                        worksheet[s].z = '0'
                        worksheet[s].t = 's'
                    }
                }
            }
        }
        // Aplica formato de moneda a las columnas correspondientes
        const range = xlsx.utils.decode_range(worksheet['!ref'] ?? '')
        for (let C = range.s.c; C <= range.e.c; ++C) {
            const header = worksheet[xlsx.utils.encode_col(C) + '1']?.v
            if (currencyColumns.includes(header)) {
                for (let R = 2; R <= range.e.r + 1; ++R) {
                    const cellAddress = xlsx.utils.encode_col(C) + R
                    if (worksheet[cellAddress]) {
                        worksheet[cellAddress].z = '"$"#,##0.00; "$"-#,##0.00';
                    }
                }
            }
        }

        const workbook = { Sheets: { [worksheetName]: worksheet }, SheetNames: [worksheetName] }
        const excelBuffer = xlsx.write(workbook, {
            bookType: 'xlsx',
            type: 'array'
        })

        saveAsExcelFile(excelBuffer, nombreExcel)
    }

    const saveAsExcelFile = (buffer: Buffer, fileName: string): void => {
        import('file-saver').then(FileSaver => {
            const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
            let EXCEL_EXTENSION = '.xlsx'
            const data = new Blob([buffer], {
                type: EXCEL_TYPE
            })
            FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION)
        })
    }

    const handleExportPdf = async () => {
        setExporting(true)
        try {
            let dataToExport = data
            if (useLazyPagination && props.fetchAllForExport) {
                dataToExport = await props.fetchAllForExport()
            }
            exportPdf(dataToExport)
        } finally {
            setExporting(false)
        }
    }

    const handleExportExcel = async () => {
        setExporting(true)
        try {
            let dataToExport = data
            if (useLazyPagination && props.fetchAllForExport) {
                dataToExport = await props.fetchAllForExport()
            }
            exportExcel(dataToExport)
        } finally {
            setExporting(false)
        }
    }

    const handleGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value || ''
        setGlobalFilter(value)
        if (typeof (props as any).onFilterChange === 'function') {
            ;(props as any).onFilterChange(value)
        }
    }

    const hasServerSearch = typeof props.onSearch === 'function'

    const submitServerSearch = () => {
        if (!hasServerSearch) return
        props.onSearch?.(globalFilter || '')
    }

    const handleSearchKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (!hasServerSearch) return
        if (e.key === 'Enter') {
            e.preventDefault()
            submitServerSearch()
        }
    }

    const searchButtonStyle: React.CSSProperties = {
        marginLeft: '8px',
        marginRight: '0',
        padding: '6px 12px',
        backgroundColor: 'white',
        border: '1px solid lightgray',
        boxShadow: 'none',
        verticalAlign: 'middle',
        cursor: 'pointer',
        lineHeight: 1
    }

    const renderSearchField = (withTestId = false) => (
        <>
            {!hasServerSearch && <i className="pi pi-search" style={{ margin: '4px 4px 0 0' }} />}
            <InputText
                type="search"
                data-testid={withTestId ? 'buscar-table' : undefined}
                value={globalFilter}
                onChange={handleGlobalFilterChange}
                onKeyDown={handleSearchKeyDown}
                placeholder="Buscar..."
                width="20%"
                data-cy={`btn-search-table-${idCy}`}
            />
            {hasServerSearch && (
                <button
                    type="button"
                    className="btn"
                    aria-label="buscar-table"
                    title="Buscar"
                    onClick={submitServerSearch}
                    style={searchButtonStyle}
                >
                    <i className="pi pi-search" />
                </button>
            )}
        </>
    )

    const Header = () => {
        return headerRigth ? (
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <div style={{ textAlign: 'left', maxWidth: '10%' }}>{extra2 && extra2}</div>
                <div style={{ textAlign: 'right' }}>
                    <div className="p-clearfix" style={{ lineHeight: '1.87em' }}>
                        {renderSearchField(true)}
                        {extra && extra}
                        {noExport
                            ? null
                            : [
                                !noExcel && (
                                    <button
                                        key="1"
                                        className="btn"
                                        id="exportExcel"
                                        onClick={handleExportExcel}
                                        style={{
                                            marginLeft: '15px',
                                            backgroundColor: 'white',
                                            border: '1px solid lightgray',
                                            boxShadow: 'none'
                                        }}
                                    >
                                        <img src={excelIcon} alt="excelIcon" />
                                    </button>
                                ),
                                !noPdf && (
                                    <button
                                        key="2"
                                        className="btn "
                                        id="exportPdf"
                                        onClick={handleExportPdf}
                                        style={{
                                            marginLeft: '15px',
                                            backgroundColor: 'white',
                                            border: '1px solid lightgray',
                                            boxShadow: 'none'
                                        }}
                                    >
                                        <img src={PdfIcon} alt="PdfIcon" />
                                    </button>
                                )
                            ]}
                        {!noRefresh ? (
                            <Button
                                aria-label="refresh-table"
                                icon="pi pi-refresh"
                                onClick={() => actualizar()}
                                style={{ float: 'right' }}
                            />
                        ) : null}
                    </div>
                </div>
            </div>
        ) : (
            <div style={{ textAlign: 'left' }}>
                <div className="p-clearfix" style={{ lineHeight: '1.87em' }}>
                    {renderSearchField()}
                    {extra && extra}
                    {noExport
                        ? null
                        : props.etiquetaExcel || props.etiquetaPdf
                            ? [
                                !noPdf && (
                                    <button key="2" type="button" className="datatable__exportar" id="exportPdf" onClick={handleExportPdf}>
                                        <img src={PdfIcon} alt="" />{props.etiquetaPdf}
                                    </button>
                                ),
                                !noExcel && (
                                    <button key="1" type="button" className="datatable__exportar" id="exportExcel" onClick={handleExportExcel}>
                                        <img src={excelIcon} alt="" />{props.etiquetaExcel}
                                    </button>
                                )
                            ]
                        : [
                            !noExcel && (
                                <button
                                    key="1"
                                    className="btn"
                                    id="exportExcel"
                                    onClick={handleExportExcel}
                                    style={{
                                        marginLeft: '15px',
                                        backgroundColor: 'white',
                                        border: '1px solid lightgray',
                                        boxShadow: 'none'
                                    }}
                                >
                                    <img src={excelIcon} alt="excelIcon" />
                                </button>
                            ),
                            !noPdf && (
                                <button
                                    key="2"
                                    className="btn "
                                    id="exportPdf"
                                    onClick={handleExportPdf}
                                    style={{
                                        marginLeft: '15px',
                                        backgroundColor: 'white',
                                        border: '1px solid lightgray',
                                        boxShadow: 'none'
                                    }}
                                >
                                    <img src={PdfIcon} alt="PdfIcon" />
                                </button>
                            )
                        ]}
                    {!noRefresh ? (
                        <Button icon="pi pi-refresh" onClick={() => actualizar()} style={{ float: 'right' }} />
                    ) : null}
                </div>
            </div>
        )
    }

    const agregarSelect = (dato: any) => {
        Storage.dispatch({
            type: 'DATOS_SELECCIONADOS',
            seleccionados: dato
        })
    }

    useEffect(() => {
        const hasRemoteFilter =
            typeof (props as any).onFilterChange === 'function' || typeof props.onSearch === 'function'
        if (hasRemoteFilter || !globalFilter?.trim()) {
            setAllDataCache(null)
            return
        }
        if (!useLazyPagination || !props.fetchAllForFilter) {
            setAllDataCache(null)
            return
        }
        let cancelled = false
        setLoadingAllForFilter(true)
        props
            .fetchAllForFilter()
            .then((allRows: any[]) => {
                if (!cancelled) setAllDataCache(Array.isArray(allRows) ? allRows : [])
            })
            .catch(() => {
                if (!cancelled) setAllDataCache(null)
            })
            .finally(() => {
                if (!cancelled) setLoadingAllForFilter(false)
            })
        return () => {
            cancelled = true
        }
    }, [globalFilter, useLazyPagination])

    const shouldApplyLocalFilter = !(
        typeof (props as any).onFilterChange === 'function' || typeof props.onSearch === 'function'
    )
    const datasetBase = useLazyPagination && shouldApplyLocalFilter && globalFilter && allDataCache ? allDataCache : data

    const dataToShow =
        shouldApplyLocalFilter && globalFilter
            ? datasetBase.filter((row: any) =>
                columns.some((col) => {
                    const val = row[col.field]
                    if (val == null) return false
                    if (React.isValidElement(val)) return false
                    return String(val).toLowerCase().includes(globalFilter.toLowerCase())
                })
            )
            : datasetBase

    const isFilteringAllPages = Boolean(useLazyPagination && globalFilter && allDataCache)
    const paginatorRows = isFilteringAllPages ? filterRows : rows
    const paginatorTotalRecords = isFilteringAllPages ? dataToShow.length : props.totalRecords
    const paginatorFirst = isFilteringAllPages ? filterFirst : props.first
    const paginatorLazy = !isFilteringAllPages && Boolean(props.totalRecords != null && props.onPage)

    const ROWS_OPTIONS = [5, 10, 20, 50]

    useEffect(() => {
        if (!isFilteringAllPages || !allDataCache) return
        setFilterFirst(0)
        const n = Math.max(dataToShow.length, 1)
        setFilterRows(ROWS_OPTIONS.find(opt => opt >= n) || 50)
    }, [isFilteringAllPages, allDataCache, globalFilter, columns, dataToShow?.length])

    const handlePageWhenFiltering = (event: { first: number; rows: number }) => {
        setFilterFirst(event.first)
        setFilterRows(event.rows)
    }

    const handleSort = (e: {
        sortField?: string | null
        sortOrder?: number
        multiSortMeta?: Array<{ field: string; order: number }> | null
    }) => {
        if (e.multiSortMeta != null) {
            setMultiSortMeta(e.multiSortMeta.length > 0 ? e.multiSortMeta : null)
            const first = e.multiSortMeta[0]
            setSortField(first ? first.field : null)
            setSortOrder(first ? first.order : 1)
        } else {
            setMultiSortMeta(null)
            setSortField(e.sortField ?? null)
            setSortOrder(e.sortOrder ?? 1)
        }
    }

    const compareSortValues = (a: any, b: any, order: number): number => {
        if (a == null && b == null) return 0
        if (a == null) return order
        if (b == null) return -order
        if (React.isValidElement(a) || React.isValidElement(b)) return 0
        const aStr = String(a).toLowerCase()
        const bStr = String(b).toLowerCase()
        const cmp = aStr < bStr ? -1 : aStr > bStr ? 1 : 0
        return order * cmp
    }

    const sortedDataWhenLazy =
        paginatorLazy && sortField
            ? [...dataToShow].sort((rowA: any, rowB: any) =>
                  compareSortValues(rowA[sortField], rowB[sortField], sortOrder)
              )
            : null

    const valueForTable = sortedDataWhenLazy != null ? sortedDataWhenLazy : dataToShow

    return (
        <div className={`mx-auto ${className}`} style={{ overflow: 'auto' }}>
            <div className="content-section implementation">
                {/* @ts-ignore */}
                <PRDatatable
                    id="htmlTableId"
                    className="mx-auto"
                    value={valueForTable}
                    paginator={props.paginator !== false}
                    rows={paginatorRows}
                    lazy={paginatorLazy}
                    totalRecords={paginatorTotalRecords}
                    first={paginatorFirst}
                    onPage={isFilteringAllPages ? handlePageWhenFiltering : props.onPage}
                    header={Header()}
                    globalFilter={shouldApplyLocalFilter ? globalFilter : undefined}
                    sortMode="multiple"
                    sortField={paginatorLazy ? sortField ?? undefined : undefined}
                    sortOrder={paginatorLazy ? sortOrder : undefined}
                    multiSortMeta={paginatorLazy ? multiSortMeta ?? undefined : undefined}
                    onSort={paginatorLazy ? handleSort : undefined}
                    emptyMessage="No se encontro"
                    rowsPerPageOptions={ROWS_OPTIONS}
                    removableSort={true}
                    responsive={true}
                    autoLayout
                    selection={Storage.getState().seleccionados}
                    onSelectionChange={e => agregarSelect(e.value)}
                /* rowReorderIcon="pi pi-bars"
  rowReorder={true} */
                >
                    {props.select && <Column selectionMode="multiple" headerStyle={{ width: '3em' }}></Column>}
                    {columns != null
                        ? columns.map((col, i) => {
                            return (
                                <Column
                                    key={i}
                                    field={col.field}
                                    header={col.header}
                                    style={col.style ? col.style : { width: '300px' }}
                                    sortable={true}
                                    filterPlaceholder="Buscar..."
                                    frozen={col.frozen}
                                />
                            )
                        })
                        : null}
                </PRDatatable>
            </div>
        </div>
    )
}

export default DataTableFilterDemo
